import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './templates/breadcrumb/breadcrumb.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FilterDataComponent } from './templates/filter-data/filter-data.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MatChipsModule, } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { AddClientDialogsComponent } from './dialogs/confirm-dialog/add-client-dialogs/add-client-dialogs.component';
import { JoinPipe } from 'src/app/core/_pipes/join.pipe';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AddServiceDialogComponent } from './dialogs/confirm-dialog/add-service-dialog/add-service-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { ChoosePaymentComponent } from './dialogs/confirm-dialog/choose-payment/choose-payment.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PaymentComponent } from './dialogs/confirm-dialog/payment/payment.component';
import { ChequePaymentComponent } from './dialogs/confirm-dialog/cheque-payment/cheque-payment.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { OnlinePaymentComponent } from './dialogs/confirm-dialog/online-payment/online-payment.component';
import { PaymentCompletedComponent } from './dialogs/confirm-dialog/payment-completed/payment-completed.component';
import { AddSubscriptionComponent } from './dialogs/confirm-dialog/add-subscription/add-subscription.component';
import { DistanceUpdateComponent } from './dialogs/distance-update/distance-update.component';
import { ComingSoonDialogComponent } from './dialogs/coming-soon-dialog/coming-soon-dialog.component';
import { TakeOnlinePaymentComponent } from './dialogs/confirm-dialog/take-online-payment/take-online-payment.component';
import { AddPackageComponent } from './dialogs/confirm-dialog/add-package/add-package.component';
import { ValorInfoComponent } from './dialogs/confirm-dialog/valor-info/valor-info.component';
import { AddEmailComponent } from './dialogs/confirm-dialog/add-email/add-email.component';
import { ListingDialogComponent } from './dialogs/confirm-dialog/listing-dialog/listing-dialog.component';
import { ImageViewerComponent } from './dialogs/confirm-dialog/image-viewer/image-viewer.component';
import { AddNotesComponent } from './dialogs/confirm-dialog/add-notes/add-notes.component';
import { AddressAutoCompleteComponent } from './shared/address-auto-complete/address-auto-complete.component';
import { PlaceAutocompleteDirective } from 'src/app/core/_directives/place-autocomplete.directive';
import { SuperadminModalComponent } from './dialogs/superadmin-modal/superadmin-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from "@angular/material/tooltip";
import { ManageSubConfirmDialogComponent } from './dialogs/manage-sub-confirm-dialog/manage-sub-confirm-dialog.component';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'MMM DD, YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    BreadcrumbComponent,
    FilterDataComponent,
    ConfirmDialogComponent,
    AddClientDialogsComponent,
    AddServiceDialogComponent,
    ChoosePaymentComponent,
    PaymentComponent,
    ChequePaymentComponent,
    OnlinePaymentComponent,
    PaymentCompletedComponent,
    AddSubscriptionComponent,
    DistanceUpdateComponent,
    ComingSoonDialogComponent,
    TakeOnlinePaymentComponent,
    AddPackageComponent,
    ValorInfoComponent,
    AddEmailComponent,
    ListingDialogComponent,
    ImageViewerComponent,
    AddNotesComponent,
    AddressAutoCompleteComponent,
    PlaceAutocompleteDirective,
    SuperadminModalComponent,
    ManageSubConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    NgxUiLoaderModule,
    AngularSvgIconModule.forRoot(),
    CreditCardDirectivesModule,
    // Material Module
    MatDialogModule,
    MatDatepickerModule,
    MatIconModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    GooglePlaceModule,
    MatSelectModule,
    ReactiveFormsModule,
    DragDropModule,
    MatTooltipModule
],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }
  ],
  exports: [
    BreadcrumbComponent, FilterDataComponent, NgxPaginationModule, AddServiceDialogComponent, MatDialogModule, MatIconModule, MatIcon, MatChipsModule, MatAutocompleteModule,
    GooglePlaceModule, ReactiveFormsModule],
  entryComponents: [
    ConfirmDialogComponent, BreadcrumbComponent
  ]
})
export class PartialsModule { }
